// export const apiBaseURL = 'http://192.168.253.8.hu/';
// export const apiBaseURL = 'http://api-idokapu.maxserver-systemd.hu/';
export const apiBaseURL = 'https://rlapapi.enger.hu/';
export const fileURL = 'https://idokapu.enger.hu/';
